import { Home, MessageSquare, Settings, ShieldCheck, Sparkles } from 'lucide-react'

export interface FounderNavLeaf {
  label: string
  to: string
  /** Search params applied when navigating (e.g. the outreach channel tab) */
  search?: Record<string, string>
}

export interface FounderNavEntry {
  icon: React.ElementType
  label: string
  /** Set on links (Home, Settings). Groups omit it — they only expand. */
  to?: string
  /** Set on groups. A group is a toggle, never a destination. */
  children?: FounderNavLeaf[]
}

export const FOUNDER_NAV_HOME: FounderNavEntry = { icon: Home, label: 'Home', to: '/' }

/** The Share your Profile leaf: carries the combined "contacts to review" badge and the SeedForge Outreach card's badge. */
export const FOUNDER_NAV_SHARE_PROFILE_LABEL = 'Share your Profile'
export const FOUNDER_NAV_EMAIL_UPDATES_LABEL = 'Email updates'

/** SeedForge Outreach sub tabs: each carries its campaign's count of contacts awaiting approval. */
export const FOUNDER_NAV_INVESTOR_CAMPAIGN_LABEL = 'Investor outreach'
export const FOUNDER_NAV_WARM_INTRO_CAMPAIGN_LABEL = 'Warm-intro'

/** Share Analytics is a Feedback leaf; it needs no evaluation, so it is never disabled with one. */
export const FOUNDER_NAV_SHARE_ANALYTICS_LABEL = 'Share Analytics'

/** Leaf badged with the number of replies across both campaigns. */
export const FOUNDER_NAV_REPLIES_LABEL = 'Outreach Outcomes'

/** Feedback leaf built on the evaluation; disabled until one exists. */
export const FOUNDER_NAV_INVESTOR_FEEDBACK_LABEL = "Investor's Feedback"

/** Leaf carrying the approved-queue runway state. Lives under the Share your Profile tab row, not the sidebar. */
export const FOUNDER_NAV_MATCHED_INVESTORS_LABEL = 'Matched investors'

/** Group labels — the units the app gates on. Disabling one disables its children. */
export const FOUNDER_NAV_PROFILE_GROUP_LABEL = 'Profile'
export const FOUNDER_NAV_PROOF_GROUP_LABEL = 'Proof'
export const FOUNDER_NAV_FEEDBACK_GROUP_LABEL = 'Feedback'

/** Leaf badged when an evaluation the founder has not opened yet is ready. */
export const FOUNDER_NAV_SEEDFORGE_FEEDBACK_LABEL = "SeedForge's Feedback"

export const FOUNDER_NAV_GROUPS: FounderNavEntry[] = [
  {
    icon: ShieldCheck,
    label: FOUNDER_NAV_PROFILE_GROUP_LABEL,
    children: [
      { label: 'SeedForge Profile', to: '/profile' },
      { label: FOUNDER_NAV_SHARE_PROFILE_LABEL, to: '/profile/links' },
    ],
  },
  {
    icon: Sparkles,
    label: FOUNDER_NAV_PROOF_GROUP_LABEL,
    children: [
      { label: 'AI Session', to: '/pitch/start' },
      { label: FOUNDER_NAV_EMAIL_UPDATES_LABEL, to: '/updates' },
    ],
  },
  {
    icon: MessageSquare,
    label: FOUNDER_NAV_FEEDBACK_GROUP_LABEL,
    children: [
      { label: FOUNDER_NAV_SEEDFORGE_FEEDBACK_LABEL, to: '/pitch' },
      { label: FOUNDER_NAV_INVESTOR_FEEDBACK_LABEL, to: '/profile/deep-insights' },
      { label: FOUNDER_NAV_SHARE_ANALYTICS_LABEL, to: '/profile/analytics' },
      { label: FOUNDER_NAV_REPLIES_LABEL, to: '/outreach/replies' },
    ],
  },
]

export const FOUNDER_NAV_SETTINGS: FounderNavEntry = {
  icon: Settings,
  // Named for what it settings: this page is the startup's, not the person's.
  // Account-level items live under the user menu.
  label: 'Startup settings',
  to: '/settings',
}
